module.exports = __webpack_public_path__ + "media/images/client-hankook-3479b0cc1e8201221c57eb9fb075b23a.svg";